// US State options for react-select dropdowns (50 states + DC)
export const STATE_OPTIONS = [
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DC", label: "District Of Columbia" },
  { value: "DE", label: "Delaware" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" },
  { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PA", label: "Pennsylvania" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" },
  { value: "VA", label: "Virginia" },
  { value: "WA", label: "Washington" },
  { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" },
  { value: "WY", label: "Wyoming" }
];

// Account type options for bank payment
export const ACCOUNT_TYPE_OPTIONS = [
  { value: 'checking', label: 'Checking' },
  { value: 'savings', label: 'Savings' }
];

// Shared react-select styles for dark theme
export const getSelectStyles = (customHeight = 68) => ({
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#00000045',
    border: '1px solid #ffffff3f',
    color: '#fff',
    borderRadius: 8,
    fontFamily: "'SF Mono', 'Roboto Mono', 'Menlo', 'Monaco', 'Consolas', 'monospace'",
    fontSize: '1.25rem',
    fontWeight: 400,
    minHeight: customHeight,
    height: customHeight,
    boxShadow: 'none',
    paddingLeft: 8,
    paddingRight: 0,
    outline: state.isFocused ? 'none' : undefined,
    borderColor: state.isFocused ? '#ffffff3f' : '#ffffff3f',
    alignItems: 'center',
    '&:hover': {
      borderColor: 'initial',
    },
    '&:focus-within': {
      outline: '3px solid #ffffffdc',
      outlineOffset: '2px',
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0 0.8rem',
    height: customHeight,
    display: 'flex',
    alignItems: 'center',
  }),
  input: (provided) => ({
    ...provided,
    color: '#fff',
    fontSize: '1.25rem',
    margin: 0,
    padding: 0,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#fff',
    fontSize: '1.25rem',
    margin: 0,
    padding: 0,
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#fff',
    paddingRight: 12,
    paddingLeft: 0,
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: '#23232a',
    color: '#fff',
    borderRadius: 8,
    marginTop: 2,
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
  option: (provided, state) => ({
    ...provided,
    fontFamily: "'SF Mono', 'Roboto Mono', 'Menlo', 'Monaco', 'Consolas', 'monospace'",
    backgroundColor: state.isSelected
      ? '#F51E84'
      : state.isFocused
      ? 'rgba(255, 255, 255, 0.08)'
      : '#23232a',
    color: '#fff',
    fontSize: '1.1rem',
    padding: '10px 20px',
    '&:active': {
      backgroundColor: 'rgba(255, 255, 255, 0.16)',
    },
  }),
});

// Recurly element styling
export const RECURLY_ELEMENT_STYLE = {
  fontSize: '1.25rem',
  fontFamily: "'SF Mono', 'Roboto Mono', 'Menlo', 'Monaco', 'Consolas', 'monospace'",
  fontColor: '#ffffff',
  backgroundColor: '#2a2a2a',
  border: '1px solid #444',
  borderRadius: '4px',
  padding: '12.8px',
  placeholder: {
    color: '#aaa'
  },
  invalid: {
    color: '#ff6b6b',
    border: '1px solid #ff6b6b'
  }
};

// Email validation domains
export const INVALID_EMAIL_DOMAINS = ['test.com', 'example.com', 'localhost', 'test.test', 'fake.com'];
export const DISPOSABLE_EMAIL_DOMAINS = [
  '10minutemail.com', 'guerrillamail.com', 'mailinator.com', 'tempmail.org',
  'yopmail.com', 'throwaway.email', 'getnada.com', 'sharklasers.com'
];

// Timeouts
export const PROMO_CODE_AUTO_APPLY_DELAY = 2000;
export const TOKEN_TIMEOUT = 10000;
export const PROMO_SUCCESS_MESSAGE_DELAY = 2000;
export const RECURLY_OBSERVER_TIMEOUT = 1000;

// Re-export plan-related constants and functions from planService (single source of truth)
export {
  LENDER_PLANS,
  REAL_ESTATE_PLANS,
  INSURANCE_PLANS,
  TITLE_PLANS,
  MONTHLY_ONLY_PLANS,
  isLenderPlan,
  isRealEstatePlan,
  isInsurancePlan,
  isTitlePlan
} from '../services/planService';
